import { render, staticRenderFns } from "./menuManager.vue?vue&type=template&id=585f5ee3"
import script from "./menuManager.vue?vue&type=script&lang=js"
export * from "./menuManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports